<template>
  <transition name="fade">
    <div class="toast-back" v-if="show">
      <div class="toast">{{message}}</div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: "toast",
    data () {
      return {
        message: '',
        duration: 2000,
        show: true
      }
    },
    mounted () {
      this.close();
    },
    methods: {
      close () {
        window.setTimeout(() => {
          this.show = false;
        }, this.duration);
      }
    }
  };
</script>

<style lang="less">
  .toast-back {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    .toast {
      padding: 16px 20px;
      background-color: rgba(17, 17, 17, 0.7);
      border-radius: 12px;
      color: #fff;
    }
  }
</style>
